import { Text, Title, Section as BaseSection, Link } from '../../utils/theme';
import styled from 'styled-components';

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  overflow: hidden;
  height: 60vw;
  box-shadow: 0 0 5vw 5vw #090C1B inset;

  @media (max-width: 600px) {
    height: 160vw;
  }
`;

export const AboutTitle = styled(Title)`
  position: absolute;   
  top: 0vw;
  font-size: 3vw;
  text-align: center;

  @media (max-width: 600px) {
    top: 5vw;
    font-size: 6.5vw;
  }
`;

export const AboutText = styled(Text)`
  position: absolute;   
  top: 8vw;
  width: 100w;
  font-size: 1.5vw;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 3vw;
    top: 20vw;
    width: 80vw;
  }
`;

export const ConstellationContainer = styled.div`
  @media (max-width: 600px) {
    display: none;
  }
`;

export const Constellation = styled.img<{ islit: boolean }>`
  position: absolute;
  top: 19vw;
  left: 7vw;
  width: 50vw;
  filter: ${({ islit }) => (islit ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const CharacterTelescope = styled.img` 
  position: absolute;
  top: 38vw;
  left: 3vw;
  width: 25vw;
  @media (max-width: 600px) {
    top: 135vw;
    left: 0vw;
    width: 40vw;
    z-index: 1;
  }
`;

export const Card = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 20vw;
  right: 10vw;
  width: 25vw;
  height: 35vw;
  border: 0.3vw solid #F6CB00;
  border-radius: 15px;
  overflow: hidden;
  background: #090C1B;

  @media (max-width: 600px) { 
    font-size: 3.5vw;
    top: 36vw;
    left: 15vw;
    width: 70vw;
    height: 105vw;
    border: 1vw solid #F6CB00;
    z-index: 0;
  }
`;

export const PinkContainer = styled.div`
  background-color: #AA3B82;
  height: 20%;
  align-items: center;
  text-align: center;
`;

export const CardImage = styled.img`
  width: 80%;
  margin-top: 2vw;
  margin-left: 10%;
`;

export const YearText = styled(Text)`
  font-size: 2vw;
  font-weight: bold;
  padding: 0;
  margin-top: 1vw;
  margin-bottom: 0vw;
  margin-left: 0vw;
  margin-right: 0vw;
  @media (max-width: 600px) {
    margin-top: 2.5vw;
    font-size: 6.5vw;
  }
`;

export const StatsText = styled(Text)`
  font-size: 0.9vw;
  padding: 0;
  margin: 0;
  @media (max-width: 600px) {
    font-size: 3vw;
  }
`;

export const CaptionText = styled(Text)`
  font-size: 1vw;
  font-style: italic;
  text-align: center;
  padding-left: 0.5vw;
  padding-right: 0.5vw;
    @media (max-width: 600px) {
    font-size: 3vw;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }
`;

export const DataText = styled(Text)`
  font-size: 0.9vw;
  text-align: center;
  padding-left: 0.5vw;
  padding-right: 0.5vw;
  @media (max-width: 600px) {
    font-size: 3vw;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }
`;

export const DataLink = styled(Link)`
  margin: 0vw;
  padding: 0vw;
  font-size: 0.8vw;
  text-align: center;
  text-decoration: underline;
  padding-left: 0.5vw;
  padding-right: 0.5vw;
  @media (max-width: 600px) {
    font-size: 3vw;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }
`

export const LeftArrow = styled.img`
  padding: 0;
  margin: 0;
  position: absolute;
  top: 34.5vw;
  left: 65.4vw;
  width: 1vw;
  z-index: 1;
  @media (max-width: 600px) {
    display: none;
  }
`;

export const RightArrow = styled.img`
  padding: 0;
  margin: 0;
  position: absolute;
  top: 34.5vw;
  left: 87.9vw;
  width: 1vw;
  z-index: 1;
  @media (max-width: 600px) {
    display: none;
  }
`;

export const Star2014 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 22vw;
  left: 8vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2015 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 34vw;
  left: 12vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2016 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 21.5vw;
  left: 21vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2017 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 32.5vw;
  left: 20.5vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2018 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 24.5vw;
  left: 28vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2019 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 19.5vw;
  left: 37vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2020 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 26vw;
  left: 39.5vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2021 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 33.5vw;
  left: 33.5vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2022 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 21vw;
  left: 49vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2023 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 28vw;
  left: 43vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const Star2024 = styled.img<{ isclicked: boolean }>`
  position: absolute;
  top: 34.5vw;
  left: 47.5vw;
  width: 4vw;
  filter: ${({ isclicked }) => (isclicked ? 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))' : 'none')};
`;

export const BackgroundImage = styled.img`
  z-index: -1;
  position: absolute;
  top: 0vw;
  width: 100vw;

  @media (max-width: 600px) {
    left: 0vw;
    top: 0vw;
    width: 100vw;
    min-height: 300vw;
  }
`;
